import type { FC } from 'react';
import React, { memo } from 'react';
import cn from 'classnames';

import type { TCaption } from './models';

const CaptionComponent: FC<TCaption> = ({
    children,
    className,
    dataTestId = 'caption',
    size = 'xs',
    styles,
    theme,
}) => {
    let classnames = styles.caption;

    if (theme) {
        classnames = cn(classnames, {
            [styles[`${theme}Theme`]]: theme,
        });
    }

    classnames = cn(classnames, styles[`${size}Size`], className);

    return (
        <div className={classnames} data-test-id={dataTestId}>
            {children}
        </div>
    );
};

export const Caption = memo(CaptionComponent);
